<app-common-header></app-common-header>

<main role="main" class="maincnt quest">
  <div class="getbannersect pb-2">
    <div class="col-sm-12 p-0">
      <a
        href="javascript:void(0)"
        class="backbtn webview arrowlft"
        (click)="back()"
      ></a>
    </div>
    <div class="sectpad container">
      <div class="col-12 text-center webview">
        <!-- <img src="assets/images/eva-icons.svg" class="signimg" width="100" /> -->
      </div>
      <div class="col-sm-12 pt-4 pl-0 pr-0 mt-5">
        <h1 class="text-center fwgtsix font40 webview">
          Great decision on choosing this plan!
        </h1>
        <h1 class="text-center font35 subtitle webview mb-5">
          You’re less than 90 seconds away from <br />
          signing up for this plan.
        </h1>
        <div class="container mobileview mt-0 pr-0 pt-4">
          <div class="d-flex h-100 row col-sm-12 pr-3 mt-0">
            <div
              class="
                justify-content-center
                align-self-center
                col-sm-3 col-3
                pl-0
              "
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div class="arrow_box">
                <h1 class="questionMob text-left">
                  Great decision on choosing this plan! You’re less than 90
                  seconds away from completing the sign up process.
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-10 m-auto p-0 mbwidth">
          <h3 class="font18 text-center mt-4 mb-4 fwgtfive">
            Your Plan Summary
          </h3>
          <div class="plansummary webview othershadw">
            <div class="d-flex bdrbot align-items-stretch no-gutters px-2">
              <div class="col-2 text-left img-responsive planratt pt-4">
                <img src="{{ selectedProduct.energy_provider_image }}" 
                style=" 
                  padding-left: 5px;
                  padding-right: 5px;"
                />
                <p class="m-1 font15 font-weight-normal-calibre" id="puctid">
                  PUCT #{{ selectedProduct.puct }}
                </p>
                <div
                  class="handsymbol"
                  style="margin-top: 20px;
                  background: #F0F0F0;
                  margin-left: 10px;
                  padding: 5px 15px;
                  
                  font-size: 16px;"
                  
                >
                <span (click)="showFilterCard(selectedProduct)">
                  See Plan Details
                  <mat-icon
                    class="handsymbol"
                    style="position: absolute"
                 
                    >{{ showFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
                  >
                </span>
                </div>
              </div>
              <div class="col-10 p-0">
                <table class="plansection">
                  <colgroup>
                    <col width="32%" />
                    <col width="28%" />
                    <col width="20%" />
                    <col width="20%" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td class="wd50 pl-2">
                        <div
                          style="font-size: 16px; font-family: 'Calibre-Bold'"
                        >
                          
                          {{ selectedProduct.terms }} Months |
                          {{ selectedProduct.ProductType }}
                        </div>
                        <p *ngIf=" selectedProduct.energy_provider !== 'Texpo Energy'" >{{ math.round(selectedProduct.Renewable) }}% Renewable</p>
                      </td>
                      <!-- <td class="wd50 pl-2">
                        <div
                          style="font-size: 34px; font-family: 'Calibre-Bold'"
                        >
                          ${{
                            math.round(
                              selectedProduct.new_tier.ave_monthly_bill
                            )
                          }}
                        </div>
                        <p style="margin-top: 5px">
                          Avg. Monthly Bill Estimate
                        </p>
                        <p>
                          for
                          {{
                            math.round(
                              selectedProduct.new_tier.ave_monthly_usage
                            )
                          }}
                          kWh avg usage*
                        </p>
                      </td>
                      <td class="wd50 pl-2">
                        <div
                          style="font-size: 34px; font-family: 'Calibre-Bold'"
                        >
                          {{
                            (
                              selectedProduct.new_tier.ave_price_per_KWH * 100
                            ).toFixed(1) + '¢'
                          }}
                        </div>
                        <p style="margin-top: 5px">
                          Avg Price per {{ productTitle }}*
                        </p>
                        <p>
                          (${{
                            math.round(
                              selectedProduct.new_tier.ave_monthly_bill
                            )
                          }}
                          <span>&#247; </span
                          >{{
                            math.round(
                              selectedProduct.new_tier.ave_monthly_usage
                            )
                          }}kWh)
                        </p>
                      </td>
                      <td class="wd50 wrdbrk pl-2">
                        <p
                          class="fwgtsix"
                          style="
                            font-size: 50px;
                            font-family: 'Calibre-Bold';
                            color: deeppink;
                            line-height: 29px;
                          "
                        >
                          {{
                            (
                              selectedProduct.new_tier.ave_price_per_KWH * 100
                            ).toFixed(1) + '¢'
                          }}
                        </p>
                        <p class="font-weight-normal-calibre wrdbrk">per Kwh</p>
                        <p
                          class="font-weight-normal-calibre wrdbrk"
                          *ngIf="
                            selectedProduct.ETF &&
                            selectedProduct.ETFTypeId === 2
                          "
                        >
                          ${{ selectedProduct.ETF }} per month remaining
                        </p>
                      </td> -->

                      <td class="wd50 pl-2">
                       

                        <table width="100%" style="text-align:center;
                         
                        background: #F0F0F0;
                      ">
                        <tbody>
                          <tr>
                            <th>500 kWh</th>
                            <th>1000 kWh</th>
                            <th>2000 kWh</th>
                          </tr>
                          <tr style="line-height: 0.5;font-size: 16px;">
                            <td style="padding: 0px !important;">{{(selectedProduct.tier[0].avg_charge * 100).toFixed(1)}}¢</td>
                            <td style="padding: 0px !important;">{{(selectedProduct.tier[1].avg_charge * 100).toFixed(1)}}¢</td>
                            <td style="padding: 0px !important;">{{(selectedProduct.tier[2].avg_charge * 100).toFixed(1)}}¢</td>
                          </tr>
                        </tbody>
                      </table>

                      <highcharts-chart
                      [Highcharts]="Highcharts"
                      [options]="{
                        chart: { type: 'line', backgroundColor: 'transparent'}, 
                        xAxis: {
                          visible: false
                        },
                        yAxis: {
                          visible: false
                        },
                        legend: {
                          enabled: false
                        },
                        credits: {
                          enabled: false
                        },
                        tooltip: {
                          pointFormat: '{point.y}¢',
                          headerFormat: '',
                          footerFormat: ''
                        },
                        title: { text: ''},
                        series: [{ data: [+(selectedProduct.tier[0].avg_charge * 100).toFixed(1),
                                          +(selectedProduct.tier[1].avg_charge * 100).toFixed(1),
                                          +(selectedProduct.tier[2].avg_charge * 100).toFixed(1)
                                        ],
                                color: 'black' }]
                        
                      }"
                      [runOutsideAngular]="true"
                      style="width: 100%; height: 70px; display: block;
                          padding-left: 10px;
                          background: #F0F0F0;
                          padding-right: 10px;
                          padding-top:10px
                      "
                    ></highcharts-chart>
                    

                      </td>
                      

                      <td class="wd50 pl-2">
                        <div
                          style="font-size: 34px; font-family: 'Calibre-Bold'"
                        >
                          ${{
                            math.round(selectedProduct.new_tier.ave_monthly_bill)
                          }}
                        </div>
                        <p style="margin-top: 5px">
                         Monthly Bill Estimate
                        </p>
                        <p>
                          for
                          {{
                            math.round(selectedProduct.new_tier.ave_monthly_usage)
                          }}
                          kWh avg usage*
                        </p>
                      </td>
                      <td class="wd50 wrdbrk pl-2">
                        <p
                          class="fwgtsix"
                          style="
                            font-size: 50px;
                            font-family: 'Calibre-Bold';
                            color: deeppink;
                            line-height: 29px;
                          "
                        >
                          {{
                            (
                              selectedProduct.new_tier.ave_price_per_KWH * 100
                            ).toFixed(1) + '¢'
                          }}
                        </p>
                        <p style="margin-top: 5px">
                          Avg Price per {{ selectedProduct.energy_units }}*
                        </p>
                        <p>
                          (${{
                            math.round(selectedProduct.new_tier.ave_monthly_bill)
                          }}
                          <span>&#247; </span
                          >{{
                            math.round(selectedProduct.new_tier.ave_monthly_usage)
                          }}kWh)
                        </p>
                      </td>

                      

                    </tr>
                    <tr>
                      <td colspan="3">
                        <div class="plan webview align-items-center pb-1">
                          <!-- <div class="plandesc">
                            <span
                              style="
                                font-size: 20px;
                                font-weight: 600;
                                margin-bottom: 10px;
                                display: block;
                              "
                              >{{ selectedProduct.product_key }}</span
                            >
                            <p
                              class="font-weight-normal-calibre text-left"
                              [innerHTML]="selectedProduct.description"
                            ></p>
                          </div> -->
                        </div>
                      </td>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="webview" *ngIf="showFilters">
              <div
                class="px-2"
                style="
                  background: #e2e2e2;
                  font-family: 'Calibre-SemiBold';
                  font-size: 15px;
                  margin-top: 10px;
                "
              >
                Plan Details
              </div>
              <div class="d-flex">
                <div class="col-3" style="max-width: 10% !important;font-size: 13px !important;text-decoration: underline;">
                  <div class="d-flex">
                    <div class="">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="pt-1 pl-1"
                        style="color: #2b2e34 !important"
                        href="{{ selectedProduct.productEFL }}"
                        target="_blank"
                        >EFL</a
                      >
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="float-left">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="pt-1 pl-1"
                        style="color: #2b2e34 !important"
                        href="{{ selectedProduct.productTOS }}"
                        target="_blank"
                        >TOS</a
                      >
                    </div>
                  </div>
                  <div class="d-flex">
                    <div class="float-left">
                      <img src="assets/images/pdf.svg" width="18" />
                    </div>
                    <div>
                      <a
                        class="pt-1 pl-1"
                        style="color: #2b2e34 !important"
                        href="{{ selectedProduct.productYRAC }}"
                        target="_blank"
                        >YRAC</a
                      >
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <div class="plandesc" style="padding-left: 0px; padding-top: 5px;">
                    <span
                      style="
                        font-size: 16px;
                        font-weight: 600;
                        margin-bottom: 0px;
                        display: block;
                        font-family: 'Calibre-Bold';
                      "
                      >{{ selectedProduct.product_key }}</span
                    >
                    <p
                      class="font-weight-normal-calibre text-left"
                      [innerHTML]="selectedProduct.description"
                    ></p>
                  </div>
                  <div class="" style="line-height: 15px">
                    <span
                      style="font-size: 16px; font-family: 'Calibre-SemiBold'"
                      >Early Cancellation</span
                    ><br />
                    <span>
                      {{
                        setCancellationText(selectedProduct.cancellation_fee)
                      }}
                    </span>
                  </div>
                  <div class="row">
                    <span
                      style="font-size: 16px; font-family: 'Calibre-SemiBold'"
                      >Pricing Details</span
                    >
                    <div>
                      <table class="plantbl text-center">
                        <thead>
                          <th class="fwgtthree" width="28%">Monthly Usage</th>
                          <th
                            *ngFor="let usageObj of selectedProduct.tier"
                            class="
                              tabpad
                              brdrgtblk
                              font-weight-normal-calibre
                              fwgtthree
                            "
                          >
                            {{ usageObj.usage }} kWh
                          </th>
                          <th class="radius2 last-th font-weight-bold-calibre">
                            <span class=""></span>{{ avgMthlyUsage }} kWh
                          </th>
                        </thead>
                        <tbody>
                          <td
                            class="tabpadd radius4 brdrgtblk semi-bold"
                            style="background-color: #e2e2e2 !important"
                          >
                            Average Price per kWh
                          </td>
                          <td
                            *ngFor="let usageObj of selectedProduct.tier"
                            class="tabpadd brdrgtblk semi-bold"
                          >
                            {{ (usageObj.avg_charge * 100).toFixed(1)
                            }}<span>&#162;</span>
                          </td>
                          <td class="tabpadd radius3 last-th pdfclr semi-bold">
                            {{
                              (
                                selectedProduct.new_tier.ave_price_per_KWH * 100
                              ).toFixed(1) + '¢'
                            }}<font class="fwgtthree">Your Avg&#42;</font>
                          </td>
                        </tbody>
                      </table>
                    </div>
                    <div
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                        line-height: 16px;
                      "
                    >
                      <span style="font-family: 'Calibre-SemiBold'"
                        >Here’s how the charges are calculated:</span
                      >
                      <p *ngIf="recommendedBaseFee !== 0 && singleObj.energy_provider !== '4Change Energy' && singleObj.energy_provider !== 'Rhythm Energy' && singleObj.energy_provider !== 'APGE Energy' && singleObj.energy_provider !== 'Pulse Power' &&  singleObj.energy_provider !== 'New Power Texas' && singleObj.energy_provider !== 'Shell Energy' " class="WordSpace">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue(singleObj.energy_charge) }}
                        per kWh
                      </p>
                      <p *ngIf="recommendedBaseFee !== 0 && singleObj.energy_provider == '4Change Energy'" class="WordSpace">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_4Change(singleObj.energy_charge) }}
                        per kWh
                      </p>
                      <p *ngIf="(singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas'  || singleObj.energy_provider == 'Shell Energy') && singleObj.ProductType != 'TimeOfUse'" class="WordSpace">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_Pulse(singleObj.energy_charge) }}
                        per kWh
                      </p>
                      <div *ngIf=" (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' )  && singleObj.ProductType == 'TimeOfUse'">

                        <p  class="WordSpace">
                          <span style="font-weight: bold">Daytime Energy Charge</span>: {{ setValidatedValue_Pulse(singleObj.energy_charge) }}
                        </p>
                        <p  class="WordSpace">
                          <span style="font-weight: bold">Daytime Energy Factor</span>: 60% 
                        </p>
                        <p  class="WordSpace">
                          <span style="font-weight: bold">Nighttime Energy Charge</span>: FREE
                        </p>
                        <p  class="WordSpace">
                          <span style="font-weight: bold">Nighttime Energy Factor</span>: 40% 
                        </p>
                      </div>
                      <p *ngIf="singleObj.energy_provider == 'Frontier Utilities' || singleObj.energy_provider == 'Gexa Energy'" class="WordSpace">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue(singleObj.energy_charge) }}
                        per kWh
                      </p>
                          <p
                      *ngIf="
                        (singleObj.usage1 != null ||
                        singleObj.usage2 != null) &&
                        (singleObj.energy_provider === 'Gexa Energy' ||
                        singleObj.energy_provider ===
                            'Frontier Utilities')
                      "
                      class="WordSpace"
                    >
                    <span style="font-weight: bold">Usage Credit</span>:  {{singleObj.usage1Charge}} per billing cycle for usage >={{singleObj.usage1}} kWh
                    </p>
                      <p *ngIf="recommendedBaseFee !== 0 && (singleObj.energy_provider == 'Rhythm Energy' || singleObj.energy_provider == 'APGE Energy' )" class="WordSpace">
                        <span style="font-weight: bold">Energy Charge</span>:
                        {{ setValidatedValue_Rhythm(singleObj.energy_charge) }}
                        per kWh
                      </p>
                      <p class="WordSpace" *ngIf="recommendedBaseFee !== 0 && singleObj.energy_provider !== '4Change Energy'">
                        <span style="font-weight: bold">Base Charge</span>:
                        <!-- {{ SetBaseChargeValidatedValue(recommendedBaseFee) }}
                        per billing cycle
                        {{ recommendedBaseUsageLimit }} -->
                        {{ SetBaseChargeValidatedValue(singleObj.base_fee) }}
                        per billing cycle
                      </p>
                      


                      <p
                      *ngIf=" singleObj.base_fee != null &&
                      singleObj.energy_provider === '4Change Energy'
                        
                      "
                      class="WordSpace"
                    >
                    <span style="font-weight: bold">Base Charge</span>:
                      ${{ singleObj.base_fee}} 
                      per billing cycle
                    </p>


                      <p
                        *ngIf="
                          (singleObj.usage1 != null ||
                            singleObj.usage2 != null) &&
                          !setBaseChargeValue(singleObj)
                        "
                        class="WordSpace"
                      >
                        <span style="font-weight: bold">Usage Credit</span>:
                        {{ setBaseChargeValue(singleObj) }}
                      </p>
                      
                      <p
                      class="WordSpace"
                      *ngIf="
                        (
                        singleObj.energy_provider === 'Chariot Energy') && singleObj.billCredit !== '0' &&  singleObj.billCreditTrigger !== '0'
                      "
                    >
                    <span style="font-weight: bold">Usage Credit</span>:
                    {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.billCreditTrigger }} kWh
                    </p>
                      <p
                        
                        class="WordSpace"
                        *ngIf="
                          (
                            singleObj.energy_provider === 'New Power Texas') && singleObj.billCredit != undefined && singleObj.minEnergyUsage !== 0 &&  singleObj.billCredit !== 0
                        "
                      >
                        <span style="font-weight: bold">Usage Credit</span>:

                        {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.minEnergyUsage }} kWh
                      </p>
                      <p
                        
                        class="WordSpace"
                        *ngIf="
                          (singleObj.energy_provider === '4Change Energy')
                        "
                      >
                        <span style="font-weight: bold">Bill Credit</span>:

                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.usageTrigger }} kWh
                      </p>
                      <p
                      class="WordSpace"
                      *ngIf="singleObj.energy_provider === 'Texpo Energy'"
                    >
                    <span style="font-weight: bold">Minimum Usage Fee</span>:
                      ${{ singleObj.minEnergyCharge }} (for usage less than {{ singleObj.minEnergyUsage }} kWh)
  
                    </p>


                         <p
                        class="WordSpace"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.minEnergyCharge != 0 "
                      >
                        <span style="font-weight: bold">Minimum Usage Fee</span>:
                        ${{ singleObj.minEnergyCharge }} (all usage below {{ singleObj.minEnergyUsage }} kWh)

                      </p>
                      <p
                        class="WordSpace"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.ProductType.indexOf('Buyback') > -1 "
                      >
                          <span style="font-weight: bold">Solar Buyback Rate</span>: Real-Time Market Rate

                      </p>


                      <!-- <p *ngIf="recommendedUsageCreditFee !== 0">
                        <span style="font-weight: bold"> Usage Credit</span>:
                        ${{ recommendedUsageCreditFee }} per billing cycle for
                        usage {{ recommendedUsageCreditLimit }} kWh
                      </p> -->
                      <div
                      *ngIf="
                      singleObj.energy_provider != 'Pulse Power'  &&  singleObj.energy_provider != 'New Power Texas'
                      
                      "
                      
                      >
                      <p class="WordSpace">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                      </p>
                      <p class="WordSpace">
                        <span style="line-height: 6px; font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{
                          setValidatedTDUValue(
                            singleObj.tdu_delivery_charge_per_kwh
                          )
                        }}
                        per kWh
                      </p>
                     </div>

                     <div
                      *ngIf="
                     (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) &&  singleObj.ProductType == 'TimeOfUse'
                      
                      "
                      
                      >
                      <p class="WordSpace">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                      </p>
                      <p class="WordSpace">
                        <span style="line-height: 6px; font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{
                          setValidatedTDUValue(
                            singleObj.tdu_delivery_charge_per_kwh
                          )
                        }}
                        per kWh
                      </p>
                     </div>

                     <div
                      *ngIf="
                      (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' )  &&  singleObj.ProductType != 'TimeOfUse'
                      
                      "
                      
                      >
                      <!-- <p class="WordSpace">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        Bundled / Included per billing cycle
                      </p>
                      <p class="WordSpace">
                        <span style="line-height: 6px; font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        Bundled / Included
                        per kWh
                      </p> -->

                      <p class="WordSpace">
                        <span style="font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                      </p>
                      <p class="WordSpace">
                        <span style="line-height: 6px; font-weight: bold"
                          >TDU Delivery Charge</span
                        >:
                        {{
                          setValidatedTDUValue(
                            singleObj.tdu_delivery_charge_per_kwh
                          )
                        }}
                        per kWh
                      </p>

                     </div>

                      <p class="WordSpace"
                      *ngIf="
                        (singleObj.energy_provider === 'Chariot Energy' ||
                        singleObj.energy_provider === 'APGE Energy')
                        "
                      
                      >
                        <span style="font-weight: bold"
                          >{{ singleObj.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}</span
                        >: ${{singleObj.SecuritizationCharge}} per kWh
                        
                      </p>

                    </div>

                    <div
                    *ngIf="singleObj.energy_provider !== 'Pulse Power' &&  singleObj.energy_provider != 'New Power Texas'"
                      class="WordSpace"
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                        padding-bottom: 8px;
                      "
                    >
                      *Avg. Price per kWh = ({{
                        selectedProduct.energy_provider
                      }}
                      Energy Charges {{ singleObj.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+ TDU Charges {{singleObj.energy_provider === 'Chariot Energy' || singleObj.energy_provider === 'APGE Energy' ?  singleObj.SecuritizationChargeLabel : ""}}) / Total Monthly Usage
                    </div>
                    <div
                    *ngIf="(singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider === 'New Power Texas' ) && singleObj.ProductType != 'TimeOfUse'"
                      class="WordSpace"
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                        padding-bottom: 8px;
                      "
                    >
                    *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                    </div>
                    <div
                    *ngIf="(singleObj.energy_provider === 'Pulse Power' || singleObj.energy_provider === 'New Power Texas' ) && singleObj.ProductType == 'TimeOfUse'"
                      class="WordSpace"
                      style="
                        font-size: 16px;
                        font-family: Calibre;
                        padding-bottom: 8px;
                      "
                    >
                     *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobileview">
            <div
              id="prductListObj{{ selectedProduct.ProductID }}"
              class="plansummary othershadw mb-3 disableborder"
            >
              <div class="d-flex pr-0 mbswipe">
                <div
                  class="col-sm-9 col-md-8 col-lg-7 p-0 bdrrgtgry gesture__zone"
                >
                  <div
                    class="
                      row
                      no-gutters
                      align-items-center align-items-stretch
                    "
                  >
                    <div class="">
                      <div class="row no-gutters align-items-center">
                        <div class="col">
                          <div class="bdrrgtgry p-2">
                            <div
                              class="wrdbrk text-left"
                              style="
                                font-size: 14px;
                                font-family: 'Calibre-SemiBold';
                                line-height: 16px;
                              "
                            >
                              <img
                                src="{{
                                  getImagesPerEnergyProviders(
                                    selectedProduct.energy_provider
                                  )
                                }}"
                              />
                            </div>
                            <div
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              style="line-height: 12px"
                            >
                              PUCT #{{ selectedProduct.puct }}
                            </div>
                          </div>
                        </div>
                          <div class="col">
                          <div class="p-2">
                            <h1
                              class="
                                fwgtsix
                                rate
                                mt-0
                                mob-pt-5
                                avgvalue
                                mobavgpricelen32
                              "
                            >
                              {{ selectedProduct.price_units
                              }}{{
                                math.round(
                                  selectedProduct.new_tier.ave_monthly_bill
                                )
                              }}
                            </h1>
                            <div style="line-height: 13px;">
                              Avg Bill Estimate*
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="p-2">
                            <h1
                              class="
                                clrpink
                                fwgtsix
                                pikclr
                                avgvalue
                                mobavgpricelen32
                              "
                            >
                              {{
                                (
                                  selectedProduct.new_tier.ave_price_per_KWH *
                                  100
                                ).toFixed(1)
                              }}¢
                            </h1>
                            <div style="line-height: 13px;">
                              Avg. Price per kWh*
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr class="m-0" />
                      <div class="row no-gutters align-items-center">
                        <div class="col">
                          <div class="bdrrgtgry p-2">
                            <div
                              class="wrdbrk text-left"
                              style="
                               
                                font-family: 'Calibre-SemiBold';
                                line-height: 16px;
                              "
                            >
                              {{ selectedProduct.product_key }}
                            </div>
                            <div
                              class="
                                font-weight-normal-calibre
                                wrdbrk
                                text-left
                              "
                              style="line-height: 12px"
                            >
                              {{ selectedProduct.terms }} Months - 
                              {{ selectedProduct.categoryName }}
                            </div>
                            <div
                              class="fwgtsix text-left"
                              *ngIf="selectedProduct.Renewable && selectedProduct.energy_provider !== 'Texpo Energy'" 
                            >
                              <a
                                class="float-left pikclr"
                              
                                target="_blank"
                                >{{ math.round(selectedProduct.Renewable) }}% Renewable</a
                              >
                            </div>
                            <div
                              style="
                               padding-top: 8px;
                                clear: both;
                                line-height: 4px;
                                text-decoration: underline;
                              "
                              class="text-left"
                              (click)="openDialog(selectedProduct)"
                            >
                              Show Details <mat-icon
                              style="position: absolute; font-size: 16px !important;line-height: inherit;"
                              class="pointer"
                            
                              >{{ 
                                showAll
                                ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon
                            >
                            </div>
                          </div>
                        </div>
                        <div class="col" style="padding: 5px;">
                        <table width="100%" style="text-align: center; background: #F0F0F0; ">
                        <tbody>
                          <tr>
                            <th>500 kWh</th>
                            <th>1000 kWh</th>
                            <th>2000 kWh</th>
                          </tr>
                          <tr style="line-height: 0.5;">
                              <td style="padding: 0px !important;">{{(selectedProduct.tier[0].avg_charge * 100).toFixed(1)}}¢</td>
                              <td style="padding: 0px !important;">{{(selectedProduct.tier[1].avg_charge * 100).toFixed(1)}}¢</td>
                              <td style="padding: 0px !important;">{{(selectedProduct.tier[2].avg_charge * 100).toFixed(1)}}¢</td>
                          </tr>
                        </tbody>
                      </table>

                      <highcharts-chart
                      [Highcharts]="Highcharts"
                      [options]="{
                        chart: { type: 'line', backgroundColor: 'transparent'}, 
                        xAxis: {
                          visible: false
                        },
                        yAxis: {
                          visible: false
                        },
                        legend: {
                          enabled: false
                        },
                        credits: {
                          enabled: false
                        },
                        tooltip: {
                          pointFormat: '{point.y}¢',
                          headerFormat: '',
                          footerFormat: ''
                        },
                        title: { text: ''},
                        series: [{ data: [+(selectedProduct.tier[0].avg_charge * 100).toFixed(1),
                                          +(selectedProduct.tier[1].avg_charge * 100).toFixed(1),
                                          +(selectedProduct.tier[2].avg_charge * 100).toFixed(1)
                                        ],
                                color: 'black' }]
                        
                      }"
                      [runOutsideAngular]="true"
                      style="width: 100%; height: 70px; display: block;
                          padding-left: 10px;
                          background: #F0F0F0;
                          padding-right: 10px;
                          padding-top:10px
                      "
                    ></highcharts-chart>
                    
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="showAll === true">
                <hr class="mt-2 mb-1" />
                <div class="plan mobileview row no-gutters px-2">
                  <div class="col-sm-4 col-md-4 col-lg-4 plandesc pt-2">
                    <p
                      class="fwgtsix"
                      style="font-size: 16px; font-weight: bolder"
                    >
                      Description
                    </p>
                    <p
                      class="font-weight-normal-calibre text-left"
                      style="font-size: 16px"
                      [innerHTML]="selectedProduct.description"
                    ></p>
                  </div>
                  <div class="d-flex mt-1" >
                    <div class="col-2 d-flex flex-row pl-0 text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pt-1 pl-1"
                          href="{{ selectedProduct.productEFL }}"
                          target="_blank"
                          style="color: black !important; text-decoration: underline;"
                          >EFL</a
                        >
                      </div>
                    </div>

                    <div class="col-2 d-flex flex-row flexauto text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pt-1 pl-1"
                          href="{{ selectedProduct.productTOS }}"
                          target="_blank"
                          style="color: black !important; text-decoration: underline"
                          >TOS</a
                        >
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-row flexauto pr-0 text-left">
                      <div class="float-left">
                        <img src="assets/images/pdf.svg" width="18" />
                      </div>
                      <div>
                        <a
                          class="float-left pt-1 pl-1"
                          href="{{ selectedProduct.productYRAC }}"
                          target="_blank"
                          style="color: black !important; text-decoration: underline"
                          >YRAC</a
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-8 col-md-8 col-lg-8 pt-2">
                    <p
                      class="fwgtsix text-left"
                      style="font-size: 16px; font-weight: bolder"
                    >
                      Pricing Details
                    </p>
                    <div class="rounded">
                      <div>
                        <table class="table" style="margin-bottom: 0px">
                          <thead>
                            <tr style="background: #e2e2e2">
                              <th
                                scope="col"
                                class="font16 bold text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                "
                              >
                                Monthly Usage
                              </th>
                              <th
                                scope="col"
                                class="font16 bold text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                "
                              >
                                Average Price Per kWh
                              </th>
                              <th
                                scope="col"
                                class="font16 bold text-center"
                                style="
                                  padding: 0.05rem !important;
                                  vertical-align: top;
                                  border-top: 1px solid #dee2e6;
                                "
                              >
                                Monthly Estimate
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            style="
                              font-size: 16px;
                              font-family: Calibre;
                              text-align: center;
                              line-height: 10px;
                            "
                          >
                            <tr>
                              <td>500 kWh</td>
                              <td>{{ avgCharge500 }}¢</td>
                              <td>${{ monthlyEstimates[0] }}</td>
                            </tr>
                            <tr>
                              <td>1000 kWh</td>
                              <td>{{ avgCharge1000 }}¢</td>
                              <td>${{ monthlyEstimates[1] }}</td>
                            </tr>
                            <tr>
                              <td>2000 kWh</td>
                              <td>{{ avgCharge2000 }}¢</td>
                              <td>${{ monthlyEstimates[2] }}</td>
                            </tr>
                            <tr>
                              <td style="background: deeppink; color: white">
                                {{ math.round(averageMonthlyUsage) }} kWh
                              </td>
                              <td style="color: deeppink">
                                {{ avgPricePerKWH }}¢
                              </td>
                              <td style="color: deeppink">
                                ${{ avgMonthlyBill }}
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  font-size: 16px !important;
                                  padding: 0.05rem !important;
                                  line-height: 1
                                "
                              >
                                Your Avg*
                              </td>
                              <td></td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div>
                        <p style="font-size: 16px; font-weight: 800">
                          Here is how the plan charges above are calculated:
                        </p>
                      </div>
                      <div
                        style="
                          font-size: 16px;
                          font-family: Calibre;
                          line-height: 18px;
                        "
                      >
                        <p *ngIf=" singleObj.energy_provider == '4Change Energy'">
                          <span style="font-weight: bold">Energy Charge</span>:
                          {{ setValidatedValue_4Change(singleObj.energy_charge) }}
                          per kWh
                        </p>
                        <p *ngIf=" singleObj.energy_provider == 'Rhythm Energy'">
                          <span style="font-weight: bold">Energy Charge</span>:
                          {{ setValidatedValue_Rhythm(singleObj.energy_charge) }}
                          per kWh
                        </p>
                        <p *ngIf=" (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas'  || singleObj.energy_provider == 'Shell Energy' ) && singleObj.ProductType != 'TimeOfUse'">
                          <span style="font-weight: bold">Energy Charge</span>:
                          {{ setValidatedValue_Pulse(singleObj.energy_charge) }}
                          per kWh
                        </p>
                        <div *ngIf=" (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' )  && singleObj.ProductType == 'TimeOfUse'">

                          <p>
                            <span style="font-weight: bold">Daytime Energy Charge</span>: {{ setValidatedValue_Pulse(singleObj.energy_charge) }}
                          </p>
                          <p>
                            <span style="font-weight: bold">Daytime Energy Factor</span>: 60%
                          </p>
                          <p>
                            <span style="font-weight: bold">Nighttime Energy Charge</span>: FREE
                          </p>
                          <p>
                            <span style="font-weight: bold">Nighttime Energy Factor</span>: 40% 
                          </p>
                        </div>

                        <p *ngIf="singleObj.energy_provider !== '4Change Energy' && singleObj.energy_provider !== 'Rhythm Energy'&& singleObj.energy_provider !== 'Pulse Power' &&  singleObj.energy_provider != 'New Power Texas'  && singleObj.energy_provider !== 'Shell Energy'">
                          <span style="font-weight: bold">Energy Charge</span>:
                          {{ setValidatedValue(singleObj.energy_charge) }}
                          per kWh
                        </p>
                  

                          <p
                          *ngIf=" singleObj.base_fee != null &&
                          singleObj.energy_provider === '4Change Energy'
                            
                          "
                          class="WordSpace"
                        >
                        <span style="font-weight: bold">Base Charge</span>:
                          ${{ singleObj.base_fee}} 
                          per billing cycle
                        </p>

                        <p *ngIf="recommendedBaseFee !== 0 && singleObj.energy_provider !== '4Change Energy'">
                          <span style="font-weight: bold">Base Charge</span>:
                          
                          {{ SetBaseChargeValidatedValue(singleObj.base_fee) }}
                          per billing cycle
                        </p>
                        
                            <p
                        *ngIf="
                          (singleObj.usage1 != null ||
                          singleObj.usage2 != null) &&
                          (singleObj.energy_provider === 'Gexa Energy' ||
                          singleObj.energy_provider ===
                              'Frontier Utilities')
                        "
                        class="WordSpace"
                      >
                      <span style="font-weight: bold">Usage Credit</span>:  {{singleObj.usage1Charge}} per billing cycle for usage >={{singleObj.usage1}} kWh
                      </p>
                        
                        <p
                        class="WordSpace"
                        *ngIf="
                          (
                          singleObj.energy_provider === 'Chariot Energy') && singleObj.billCredit !== '0' &&  singleObj.billCreditTrigger !== '0'
                        "
                      >
                      <span style="font-weight: bold">Usage Credit</span>:
                      {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.billCreditTrigger }} kWh
                      </p>
                        <p
                        
                        class="WordSpace"
                        *ngIf="
                          (singleObj.energy_provider === '4Change Energy')
                        "
                      >
                        <span style="font-weight: bold">Bill Credit</span>:

                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.usageTrigger }} kWh
                      </p>
                      <p
                      class="WordSpace"
                      *ngIf="singleObj.energy_provider === 'Texpo Energy'"
                    >
                    <span style="font-weight: bold">Minimum Usage Fee</span>:
                      ${{ singleObj.minEnergyCharge }} (for usage less than {{ singleObj.minEnergyUsage }} kWh)
  
                    </p>

                          <p
                        class="WordSpace"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.minEnergyCharge != 0 "
                      >
                         <span style="font-weight: bold">Minimum Usage Fee</span>:
                        ${{ singleObj.minEnergyCharge }} (all usage below {{ singleObj.minEnergyUsage }} kWh)

                      </p>
                      <p
                        class="WordSpace"
                        *ngIf="singleObj.energy_provider === 'Shell Energy'  && singleObj.ProductType.indexOf('Buyback') > -1 "
                      >
                          <span style="font-weight: bold">Solar Buyback Rate</span>: Real-Time Market Rate

                      </p>



                        <p
                          class="WordSpace"
                          *ngIf="
                           (
                            singleObj.energy_provider === 'New Power Texas') && singleObj.billCredit != undefined && singleObj.minEnergyUsage !== 0 &&  singleObj.billCredit !== 0
                          "
                        >
                          <span style="font-weight: bold">Usage Credit</span>:
                          {{ removeminus(singleObj.billCredit) }} per billing cycle of atleast {{ singleObj.minEnergyUsage }} kWh
                        </p>

                        <!-- <p *ngIf="recommendedUsageCreditFee !== 0">
                          <span style="font-weight: bold"> Usage Credit</span>:
                          ${{ recommendedUsageCreditFee }} per billing cycle for
                          usage {{ recommendedUsageCreditLimit }} kWh
                        </p> -->
                        <div
                        *ngIf="
                         singleObj.energy_provider != 'Pulse Power' &&  singleObj.energy_provider != 'New Power Texas'
                        
                        "
                        
                        >

                        
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                        </p>
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{
                            setValidatedTDUValue(
                              singleObj.tdu_delivery_charge_per_kwh
                            )
                          }}
                          per kWh
                        </p>
                      </div>

                      <div
                        *ngIf="
                        (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) &&  singleObj.ProductType == 'TimeOfUse'
                        
                        "
                        
                        >

                        
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                        </p>
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{
                            setValidatedTDUValue(
                              singleObj.tdu_delivery_charge_per_kwh
                            )
                          }}
                          per kWh
                        </p>
                      </div>


                      <div
                        *ngIf="
                        (singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) &&  singleObj.ProductType != 'TimeOfUse'
                        
                        "
                        
                        >

                        
                        <!-- <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          Bundled / Included per billing cycle
                        </p>
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          Bundled / Included
                          per kWh
                        </p> -->

    
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{ setValidatedValue(singleObj.tdu_delivery_charge) }} per billing cycle
                        </p>
                        <p>
                          <span style="font-weight: bold"
                            >TDU Delivery Charge</span
                          >:
                          {{
                            setValidatedTDUValue(
                              singleObj.tdu_delivery_charge_per_kwh
                            )
                          }}
                          per kWh
                        </p>
                      </div>

                        <p
                        *ngIf="
                        (singleObj.energy_provider === 'Chariot Energy' ||
                        singleObj.energy_provider === 'APGE Energy')
                        "
                        >
                          <span style="font-weight: bold"
                            >{{ singleObj.energy_provider === 'Chariot Energy' ? "Ercot Securitization Charge" : "Securitization Charge" }}</span
                          >: ${{singleObj.SecuritizationCharge}} per kWh
                          
                        </p>
                        
                      </div>
                      <div
                       *ngIf=" singleObj.energy_provider != 'Pulse Power' &&  singleObj.energy_provider != 'New Power Texas' "
                        style="
                          font-size: 16px;
                          font-family: Calibre;
                          line-height: 18px;
                          padding-top: 8px;
                        "
                      >
                        *Avg. Price per kWh = ({{ productTitle }} Energy Charges {{ singleObj.energy_provider === 'APGE Energy' ? "+ Base Charge " :"" }}+ TDU
                        Charges {{singleObj.energy_provider === 'Chariot Energy' || singleObj.energy_provider === 'APGE Energy' ? singleObj.SecuritizationChargeLabel : ""}}) / Total Monthly Usage
                      </div>
                      <div
                      *ngIf="(singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) && singleObj.ProductType != 'TimeOfUse'"
                        style="
                          font-size: 16px;
                          font-family: Calibre;
                          line-height: 18px;
                          padding-top: 8px;
                        "
                      >
                      *Avg Price per kWh = (Energy Charge x Total Monthly Usage) + Base Charge
                      </div>
                      <div
                      *ngIf="(singleObj.energy_provider == 'Pulse Power' || singleObj.energy_provider == 'New Power Texas' ) && singleObj.ProductType == 'TimeOfUse'"
                        style="
                          font-size: 16px;
                          font-family: Calibre;
                          line-height: 18px;
                          padding-top: 8px;
                        "
                      >
                      *Price per kWh = [TDU Delivery Charges per Month + (Monthly billed kWh Usage x (Energy Rate + TDU Delivery Charges per kWh)) - (Energy Rate x applicable Free Charging kWh Usage)]/Monthly Billed kWh Usage.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="plan mobileview row no-gutters px-2"
                  style="border-top: 0px; margin-top: 8px"
                >
                  <div
                    class="fwgtsix mb-2"
                    style="
                      font-size: 16px;
                      font-weight: bolder;
                      text-decoration: underline;
                    "
                    (click)="showHighcharts()"
                  >
                    Show More Details
                    <mat-icon
                    style="position: absolute;line-height: inherit;"
                    class="pointer"
                  
                    >{{ toggleHighcharts ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                  </div>
                </div>
                <div
                  class="col-12 p-0 mobileTrigger"
                  style="margin-top: 5px"
                  *ngIf="toggleHighcharts"
                >
                  <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="highChartsOptions"
                    [(update)]="updateValue"
                    [runOutsideAngular]="true"
                    style="width: 100%; height: 350px; display: block"
                  ></highcharts-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-3 mb-3 text-center" style="margin-bottom: 90px !important;">
          <button class="btn next mt-2 font18 text-center" (click)="next()">
            NEXT
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
<ng-template #newEnergyRates>
  <div id="serviceunavialbe">
    <div class="modal-header pr-1 pt-1">
      <div class="col-12 text-right py-0 px-0">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="newEnergyProviderRates()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
      </div>
    </div>
    <div class="modal-body pt-0">
      <h4 class="utility-modal-title font20 text-center text-uppercase">
        THESE OFFERS HAVE EXPIRED
      </h4>
      <p class="utility-sub-title font20">
        PRICE FLASH! Due to market volatility, this price is no longer being
        offered by the energy provider you have selected. However, this update
        could possibly work in your favor!
      </p>
      <br />
      <p class="utility-sub-title font20">
        Click the button below 👇 to see new rates.
      </p>
      <br />
      <p class="utility-sub-title font20">
        We appreciate your patience, and apologize In advance for any
        inconvenience, while we update our records. This may take a few seconds.
      </p>
      <div class="col-12 text-center">
        <button
          class="
            btn
            mr-2
            ml-2
            col-12
            font-weight-bold-calibre
            contbtn
            text-uppercase
            mb-3
          "
          (click)="newEnergyProviderRates()"
        >
          see new rates
        </button>
      </div>
    </div>
  </div>
</ng-template>
